import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import {
  BusinessDocumentContributor,
  ContributorOption,
  ContributorRole,
} from '../../../core/services/business-document.service';

@Component({
  selector: 'app-business-document-contributor-modal',
  standalone: false,
  templateUrl: './business-document-contributor-modal.html',
  styleUrl: './business-document-contributor-modal.scss',
})
export class BusinessDocumentContributorModal implements OnChanges {
  @Input() open = false;
  @Input() contributor: BusinessDocumentContributor | null = null;
  @Input() roles: ContributorRole[] = [];
  @Input() employeeGroups: ContributorOption[] = [];
  @Output() closed = new EventEmitter<void>();
  @Output() saved = new EventEmitter<BusinessDocumentContributor>();

  roleCode = '';
  employeeGroupId = '';
  grantsAccess = true;
  errorMessage = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['open']?.currentValue) return;
    this.roleCode = this.contributor?.contributor_role_code
      ?? this.roles.find((role) => role.code !== 'creator')?.code
      ?? '';
    this.employeeGroupId = this.contributor?.subject_id ?? '';
    this.grantsAccess = this.contributor?.grants_access ?? true;
    this.errorMessage = '';
  }

  submit(): void {
    const role = this.roles.find((item) => item.code === this.roleCode);
    if (!role || !this.employeeGroupId) {
      this.errorMessage = 'Select a contributor role and Employee Group.';
      return;
    }
    this.saved.emit({
      id: this.contributor?.id || `local:${crypto.randomUUID()}`,
      contributor_role_code: role.code,
      contributor_role_name: role.name,
      subject_type: 'employee_group',
      subject_id: this.employeeGroupId,
      grants_access: this.grantsAccess,
      active: this.contributor?.active ?? true,
    });
    this.closed.emit();
  }

}
